
const initialState = {
     dni: "",
     code:""
  }

  
  const rootReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'DNI':
        return {
               ...state ,
               dni : action.payload
      }
      case 'CODE':
        return {
               ...state ,
               code : action.payload
      }
    
      default:
        return { ...state };
    }
  };
  
  export default rootReducer;